import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Input from "@amzn/meridian/input";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert"
import {
    checkModalValidationsForAutoloaderTestPackage,
    isValidEntry, PATTERNS
} from "../../../util/Validations";
import {DraftContext} from "../../../draftSave/context/DraftSaveContext";
import {CONFIG_TYPE} from "../../../util/Constants";
import {getTestConfigKey} from "../../../util/Util";
import {getLocalizedMessage} from "../../../util/Localization";

const AddAutoLoaderTestPackageModal = (props) => {

    const {formatMessage} = props.intl;
    const {mac,intl} = props;
    const {getDraftData, addInstance, editInstance} = useContext(DraftContext);

    // Visual controls
    const {open, setOpen} = props;
    const [show, setShow] = useState(false);
    const [edit, setEdit] = useState(false);

    // Values
    const [scannables, setScannables] = useState("");
    const [sortZone, setSortZone] = useState("");
    const [length, setLength] = useState("");
    const [width, setWidth] = useState("");
    const [height, setHeight] = useState("");
    const [weight, setWeight] = useState("");

    // Error
    const [scannablesErr, setScannablesErr] = useState(false);
    const [sortZoneErr, setSortZoneErr] = useState(false);
    const [lengthErr, setLengthErr] = useState(false);
    const [widthErr, setWidthErr] = useState(false);
    const [heightErr, setHeightErr] = useState(false);
    const [weightErr, setWeightErr] = useState(false);

    function onCloseModal() {
        setShow(false);
        setOpen(false);
        resetInputState();
    }

    const autoLoaderTestPackage = {
        scannables: scannables.split(';').filter(Boolean),
        sortZone: sortZone,
        length: parseFloat(length),
        width: parseFloat(width),
        height: parseFloat(height),
        weight: parseFloat(weight)
    }

    const testConfigMap = {}
    getDraftData({stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE, subKey: mac}).forEach((value) => {
        const key = getTestConfigKey(value.scannables);
        testConfigMap[key] = {
            sortZone: value.sortZone,
            length: value.length,
            width: value.width,
            height: value.height,
            weight: value.weight
        };
    })

    const onClickConfirm = (autoLoaderTestPackage, mac) => {
        if (checkModalValidationsForAutoloaderTestPackage(autoLoaderTestPackage)) {
            setConfigData(autoLoaderTestPackage, mac);
            setOpen(false);
            resetInputState();
            setShow(false);
        } else {
            setShow(true);
        }
    }

    const prefill = () => {
        const key = getTestConfigKey(autoLoaderTestPackage.scannables);
        if (testConfigMap.hasOwnProperty(key)) {
            setEdit(true);
            resetConfigErrorDetails();
            setSortZone(testConfigMap[key].sortZone);
            setLength(testConfigMap[key].length.toString());
            setWidth(testConfigMap[key].width.toString());
            setHeight(testConfigMap[key].height.toString());
            setWeight(testConfigMap[key].weight.toString());
        } else if (edit) {
            setEdit(false);
            resetConfigDetails()
        }
    }

    function resetInputState() {
        setScannables("");
        resetConfigDetails();
        resetConfigErrorDetails();
    }

    const resetConfigDetails = () => {
        setSortZone("");
        setLength("");
        setWidth("");
        setHeight("");
        setWeight("");
    }

    const resetConfigErrorDetails = () => {
        setSortZoneErr(false);
        setLengthErr(false);
        setWidthErr(false);
        setHeightErr(false);
        setWeightErr(false);
    }

    const validateDimension = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && num > 0;
    }

    const setConfigData = (autoLoaderTestPackage, mac) => {
        if(edit) {
            editInstance({
                stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
                subKey: mac,
                instance: autoLoaderTestPackage,
                keyComparator: (config1, config2) => (
                    getTestConfigKey(config1.scannables) === getTestConfigKey(config2.scannables)
                ),
                valueComparator: (config1, config2) => {
                    return config1.sortZone === config2.sortZone &&
                        config1.length === config2.length &&
                        config1.width === config2.width &&
                        config1.height === config2.height &&
                        config1.weight === config2.weight;
                }
            });
        } else {
            addInstance({
                stateKey: CONFIG_TYPE.AUTOLOADER_TEST_PACKAGE,
                subKey: mac,
                instance: autoLoaderTestPackage
            });
        }
    }

    return (
        <Row>
            <Modal
                title={formatMessage({id: "autoloadertestconfig.addupdate"})}
                open={open}
                onClose={onCloseModal}
                scrollContainer="viewport"
                closeLabel="Close"
                bodySpacingInset="medium">
                <Column spacing={"medium"} spacingInset={"medium"}>
                    <Column spacing="200">
                        <b> {getLocalizedMessage({ intl, stringId: "modal.addheadingtest" })}
                        </b>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "bay.scannables" })}
                        </Text>
                        <Input id="scannables-input"
                               value={scannables}
                               onChange={(value) => {setScannables(value.replace(/\s/g, ''))}}
                               onBlur={() => {
                                   setScannablesErr(!isValidEntry(scannables, PATTERNS.TEST_SCANNABLE));
                                   prefill();
                               }}
                               error={scannablesErr}
                               helperText={getLocalizedMessage({ intl, stringId: "test.scannables_description" })}
                        />

                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "bay.sortzone" })}
                        </Text>
                        <Input id="sort-zone-input"
                               value={sortZone}
                               onChange={setSortZone}
                               onBlur={() => {setSortZoneErr(!isValidEntry(sortZone, PATTERNS.SORT_ZONE))}}
                               error={sortZoneErr}
                               helperText={getLocalizedMessage({ intl, stringId: "bay.sortzone_description" })
                               }/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "destination.length" })}
                        </Text>
                        <Input id="length-input"
                               type="number"
                               value={length}
                               onChange={setLength}
                               onBlur={() => {setLengthErr(!validateDimension(length))}}
                               error={lengthErr}
                               helperText={getLocalizedMessage({ intl, stringId: "destination.length_description" })}
                               />
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "destination.width" })}
                        </Text>
                        <Input id="width-input"
                               type="number"
                               value={width}
                               onChange={setWidth}
                               onBlur={() => {setWidthErr(!validateDimension(width))}}
                               error={widthErr}
                               helperText={getLocalizedMessage({intl, stringId: "destination.width_description",})
                               }/>
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "destination.height" })}
                        </Text>
                        <Input id="height-input"
                               type="number"
                               value={height}
                               onChange={setHeight}
                               onBlur={() => {setHeightErr(!validateDimension(height))}}
                               error={heightErr}
                               helperText={getLocalizedMessage({ intl, stringId: "destination.height_description" })}
                        />
                    </Column>
                    <Column spacing="200">
                        <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                            {getLocalizedMessage({ intl, stringId: "destination.weight" })}
                        </Text>
                        <Input id="weight-input"
                               type="number"
                               value={weight}
                               onChange={setWeight}
                               onBlur={() => {setWeightErr(!validateDimension(weight))}}
                               error={weightErr}
                               helperText={getLocalizedMessage({intl, stringId: "destination.weight_description"})}/>
                    </Column>
                </Column>
                <ModalFooter>
                    <Column>
                        {!checkModalValidationsForAutoloaderTestPackage(autoLoaderTestPackage) &&
                            show &&
                            <Alert type="warning" size="small">
                                {getLocalizedMessage({ intl, stringId: "alert.missingfields" })}
                            </Alert>}
                    </Column>
                    <Row alignmentHorizontal="right" widths="fit">
                        <Button type="secondary" size="medium" onClick={onCloseModal}>
                            {getLocalizedMessage({ intl, stringId: "modal.cancel" })}
                        </Button>
                        <Button type="primary" size="medium"
                                onClick={() => onClickConfirm(autoLoaderTestPackage, mac)}>
                            {edit
                                ? getLocalizedMessage({ intl, stringId: "modal.confirmUpdate" })
                                : getLocalizedMessage({ intl, stringId: "modal.confirmAdd" })
                            }
                                </Button>
                    </Row>
                </ModalFooter>
            </Modal>
        </Row>
    )
}

export default injectIntl(AddAutoLoaderTestPackageModal);


// WEBPACK FOOTER //
// ./src/components/devicemanagement/autoloader/modal/AddAutoLoaderTestPackageModal.js